<template>
  <div>
    <v-toolbar style="background-color: #005ca3;" dark>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn v-if="isAuth" flat router to="/home">
          <v-icon>home</v-icon>
        </v-btn>
        <v-btn
          title="Início"
          flat
          v-for="item in menusCorretos"
          :key="item.nome"
          :to="item.link"
          style="font-weight: bold"
        >{{ item.nome }}</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      {{ loggedUser.nome }}
      <v-btn
        title="Logout"
        v-if="Object.keys(loggedUser).length != 0"
        flat
        @click="logoutUser()"
        color="white"
        dark
      >
        <v-icon>exit_to_app</v-icon>
      </v-btn>
      <v-spacer v-if="isMobile"></v-spacer>
      <v-toolbar-items v-if="isMobile">
        <v-toolbar-side-icon class="hidden-sm-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar-items>
    </v-toolbar>
    <div>
      <v-navigation-drawer fixed v-model="drawer" right v-if="isMobile">
        <v-list dense>
          <v-list-tile router to="/home">Home</v-list-tile>
          <v-list-tile v-for="item in activeMenuItens" :key="item.nome" :to="item.link">
            <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash.get";

export default {
  data: () => ({
    drawer: false,
    isMobile: false,
    temNotificacao: false,
    itensMenu: [
      { nome: "Contas Gerenciais", link: "/contas", isActive: false },
      { nome: "Centros de Custo", link: "/centrosDeCusto", isActive: false },
      { nome: "Usuários", link: "/usuarios", isActive: false },
      { nome: "Fornecedores", link: "/fornecedores", isActive: false },
      { nome: "Solicitações", link: "/solicitacoes", isActive: false },
      { nome: "Compras", link: "/compras", isActive: false }
    ]
  }),
  computed: {
    ...mapState({
      isAuth: state => state.isAuth,
      loggedUser: state => state.loggedUser
    }),
    activeMenuItens() {
      return this.itensMenu.filter(item => item.isActive === true);
    },
    menusCorretos() {
      if (this.loggedUser.papeis != undefined) {
        let menuPraRetornar = [
          { nome: "Contas Gerenciais", link: "/contas", isActive: false },
          {
            nome: "Centros de Custo",
            link: "/centrosDeCusto",
            isActive: false
          },
          { nome: "Usuários", link: "/usuarios", isActive: false },
          { nome: "Fornecedores", link: "/fornecedores", isActive: false },
          { nome: "Solicitações", link: "/solicitacoes", isActive: false },
          { nome: "Compras", link: "/compras", isActive: false }
        ];

        if (
          this.loggedUser.papeis.filter(papel => {
            return papel.nome === "ADMIN";
          }).length > 0
        ) {
          menuPraRetornar[1].isActive = true;
          menuPraRetornar[0].isActive = true;
          menuPraRetornar[3].isActive = true;
          menuPraRetornar[2].isActive = true;
          menuPraRetornar[5].isActive = true;
        }

        if (
          this.loggedUser.papeis.filter(papel => {
            return papel.nome === "ADMIN_CONTAS_GERENCIAIS";
          }).length > 0
        ) {
          menuPraRetornar[0].isActive = true;
        }

        if (
          this.loggedUser.papeis.filter(papel => {
            return papel.nome === "ADMIN_CENTROS_DE_CUSTO";
          }).length > 0
        ) {
          menuPraRetornar[1].isActive = true;
        }

        if (
          this.loggedUser.papeis.filter(papel => {
            return papel.nome === "ADMIN_FORNECEDOR";
          }).length > 0
        ) {
          menuPraRetornar[3].isActive = true;
          menuPraRetornar[5].isActive = true;
        }

        if (
          this.loggedUser.papeis.filter(papel => {
            return (
              papel.nome === "APROVADOR_FINANCEIRO_EXCECAO" ||
              papel.nome === "APROVADOR_FINANCEIRO" ||
              papel.nome === "APROVADOR_CONTABILIDADE" ||
              papel.nome === "APROVADOR" ||
              papel.nome === "PROCURADOR"
            );
          }).length > 0
        ) {
          menuPraRetornar[4].isActive = true;
        }

        if (
          this.loggedUser.papeis.filter(papel => {
            return papel.nome === "SOLICITANTE";
          }).length > 0
        ) {
          menuPraRetornar[3].isActive = true;
          menuPraRetornar[4].isActive = true;
        }
        let menuFiltrado = menuPraRetornar.filter(
          itemArray => itemArray.isActive
        );
        return menuFiltrado;
      } else return [];
    }
  },
  watch: {},
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    logoutUser() {
      this.$store.commit("set", {
        itemName: "loggedUser",
        content: {}
      });
      this.$store.commit("set", {
        itemName: "isAuth",
        content: false
      });
      localStorage.clear();
      this.$router.push("/login");
    },
    onResize() {
      this.isMobile = window.innerWidth < 960;
    }
  }
};
</script>

<style>
</style>
